import { connect } from "react-redux";
import "./style.css";
import { useEffect, useState } from "react";

function Reddot(props) {
    const [showReddot, setShowReddot] = useState(false);
    const [showReddotLS, setShowReddotLS] = useState(false);

    const { clicked } = props;
    const { notifications } = props.User;

    let notificationReddotStatus = JSON.parse(
        localStorage.getItem("notification-reddot-status")
    );

    useEffect(() => {
        if (notifications?.length) {
            for (let x = 0; x < notifications?.length; x++) {
                if (!notifications?.[x].status) {
                    setShowReddot(true);
                    break;
                }
            }

            if (!notificationReddotStatus) {
                localStorage.setItem(
                    "notification-reddot-status",
                    JSON.stringify({
                        show: true,
                        date: new Date(notifications[0]?.date),
                    })
                );
                setShowReddotLS(true);
            } else {
                let date = new Date(notificationReddotStatus?.date);
                let latest = new Date(notifications[0]?.date);

                

                if (date < latest) {
                    localStorage.setItem(
                        "notification-reddot-status",
                        JSON.stringify({
                            show: true,
                            date: new Date(notifications[0]?.date),
                        })
                    );
                    setShowReddotLS(true);
                } else {
                    setShowReddotLS(notificationReddotStatus?.show);
                }
            }
        }
    }, [notifications]);

    useEffect(() => {
        if (clicked) {
            let notificationReddotStatus = JSON.parse(localStorage.getItem(
                "notification-reddot-status"
            ));

            localStorage.setItem("notification-reddot-status", JSON.stringify({
                show: false,
                date: new Date(notificationReddotStatus?.date),
            }));
            setShowReddotLS(false);
        }
    }, [clicked]);


    return showReddotLS && showReddot ? <div id="reddot" /> : null;
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {})(Reddot);
